export const copyToClipboard = (text) => {
  try {
    navigator.clipboard.writeText(text);
  } catch (err) {
    window.clipboardData.setData("Text", text);
  }

  return;
};
